import { render, staticRenderFns } from "./ListOriginSystem.vue?vue&type=template&id=526002d7"
import script from "./ListOriginSystem.vue?vue&type=script&lang=js"
export * from "./ListOriginSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports